const state = {
  login_user: {}
}

const getters = {

}

const actions = {
  loginCall({commit}, payload){
    const api = _app.$apiEndpoints;

    return new Promise((resolve, reject) => {
      _axios.post(api.login(),{
                  email: payload.email,
                  password: payload.password
                }).then(function(response){
                  localStorage.setItem("access_token", response.data.access_token);
                  localStorage.setItem("refresh_token", response.data.refresh_token);
                  localStorage.setItem("user", JSON.stringify(response.data.user));
                  localStorage.setItem("is-login", "1");
                  commit("_loginCall", response.data)
                  resolve(response.data)
                }).catch(function(response){
                  reject(response)
                })
    })
  },
}

const mutations = {
  _loginCall(state, payload){
    state.login_user = payload.user
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
